import React, { useEffect, useState } from "react";
import { RepositoryFactory } from "../../Repository/RepositoryFactory";
import { useHistory } from "react-router-dom";
import { v4 as uuidv4 } from "uuid";
const BillsRepository = RepositoryFactory.get("bills_repository");
const LedgersRepository = RepositoryFactory.get("ledger_repository");
import BillPreview from "../reusableComponents/BillPreview";
import { convertToRFT } from "../../utils/convertToRFT";
import { convertToQty } from "../../utils/convertToQty";
import { getBillDiscount } from "../../utils/getBillDiscount";
import { addItem, clearInventory, getItems } from "../inventory/itemsSlice";
import { useDispatch, useSelector } from "react-redux";
import { updateBill, updateSaleLedger } from "./httpCalls";
import { HeadRow, ItemBox, ReturnButton, TotalBox, ValuesRow } from "./styles";
import {
  TextField,
  Box,
  Grid,
  Stack,
  Typography,
  FormControlLabel,
  Checkbox,
  InputBase,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
} from "@mui/material";
import Search from "../components/Search";
import { getQty } from "../../utils/getQty";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import deleteIcon from "../../images/del.svg";
import tick from "../../images/check-mark@2x.png";
import Loader from "../components/Loader";
import { Toast } from "../components/Toast";
import moment from "moment";
import { updateEntry } from "../ledgers/httpCalls";
import { P1, P2, P3, P4 } from "../point of sale/httpCalls";
import Repo from "../../Repository/Repo";
import { toast } from "react-toastify";
import { getLedgerDetail } from "../ledgers/detailSlice";
import DefaultRepository from "../../Repository/DefaultRepository";

import {
  returnFullBillInCashInHand,
  returnFullBillInBank,
  returnSelectedInCashInHand,
  returnSelectedInBank,
  updateBillInBank,
  updateBillInCashInHand,
} from "./httpCalls";

function UpdateBill(props) {
  const { allbill } = props?.location?.state;
  console.log("allbill", allbill);
  const dispatch = useDispatch();
  const history = useHistory();
  const inventory = useSelector((state) => state.inventory.items);
  const [Bill, setBill] = useState([]);
  console.log("billlllllllllll", Bill);
  const [items, setItems] = useState([]);
  const [addedItem, setAddedItem] = useState([]);
  console.log("addedItem", addedItem);

  console.log("itemsssss", items);
  const [loading, setLoading] = useState(false);
  const [paid, setPaid] = useState(0);
  const [state, setState] = useState({
    new_paid: 0,
    discount: 0,
    customer: "",
    balance: 0,
  });
  const [modal, setModal] = useState(false);
  const [value, setValue] = useState(false);
  const [searchText, setSearchText] = useState("");
  console.log("bnilkll", Bill);
  useEffect(() => {
    setBill(allbill);
    setItems(allbill.items);
    if (inventory.length == 0) {
      dispatch(getItems());
    }
  }, []);

  const checkIds = items.reduce((acc, item) => {
    acc[item._id] = item._id;
    return acc;
  }, {});

  const totalPrice = () => {
    let new_total = 0;
    items.map((item) => {
      let { totalPrice, discountAmount } = convertToRFT(
        Bill.saleType,
        item,
        ""
      );
      console.log("ttoalPrice", totalPrice);
      new_total += totalPrice;
    });
    let { billDiscount } = getBillDiscount(Bill, new_total);
    console.log("bill, bill", billDiscount);
    return { Total: new_total - billDiscount, subTotal: new_total };
  };

  const sellItems = async () => {
    try {
      if (searchedItems) {
        console.log("addddedItem", addedItem);
        let copyBillNew = JSON.parse(JSON.stringify(Bill));

        let Total = Bill.formallyOutstandings
          ? parseInt(Bill.formallyOutstandings + totalPrice()?.Total)
          : totalPrice()?.Total;
        copyBillNew.subTotal = totalPrice()?.subTotal;
        copyBillNew.total = Total;
        copyBillNew.formallyOutstandings = Bill.formallyOutstandings
          ? Bill.formallyOutstandings
          : "0";
        copyBillNew.items = items;
        delete copyBillNew.profit;
        const P3 = async () => {
          console.log("filtered");

          // const filteredArrayOld = items.filter((item)=> {
          //   const value = addedItem.some((addItem)=>addItem?._id  !== item?._id)
          //   return value
          // })
          // console.log("filteredArrayOld", filteredArrayOld)

          // const filteredArray = items.filter((item)=> {
          //   const value = addedItem.some((addItem)=>addItem?._id  == item?._id)
          //   return value
          // })

          // console.log("filteredArray", filteredArray)
          let tokenType = localStorage.getItem("tokenType");
          let userId = "";
          if (tokenType == "admin") {
            userId = localStorage.getItem("companyCode");
          } else {
            userId = localStorage.getItem("companyId");
          }

          return await DefaultRepository.defaultModel({
            request: {
              method: "updateItem",
              data: {
                items: items,
                action: "Sold",
                user: userId,
                billId: copyBillNew._id,
              },
            },
          });
        };

        await P3();

        await BillsRepository.billsModel({
          request: {
            method: "updateBill",
            data: {
              bill: copyBillNew,
            },
          },
        });

        setLoading(false);
        history.push("/inventory/admin/bills");
      }

      console.log("billlssd", Bill);
      let Total = totalPrice()?.Total;
      console.log("log", Total);
      let sub_total = totalPrice()?.subTotal;
      setLoading(true);
      let copyBill = JSON.parse(JSON.stringify(Bill));
      console.log("COPYBILL", copyBill);
      copyBill.items = items;
      copyBill.date = moment().format("DD-MM-YYYY");
      copyBill.subTotal = sub_total;
      copyBill.total = Total;
      console.log("COPYBILL.TOTAL", copyBill.total);
      copyBill.new_paid = Number(state.new_paid);
      copyBill.seller = localStorage.getItem("token");
      copyBill.outstandingBalance =
        Math.abs(Total) - Bill.paid > 0 ? Math.abs(Total) - Bill.paid : "0";
      copyBill.change =
        Bill.paid >= Total
          ? 0
          : Math.abs(Total - Bill.paid) > 0
          ? Math.abs(Total - Bill.paid)
          : "0";

      let newItems = items.map((item, index) => {
        item.costPrice = Number(item?.costPrice || 0);
        item.salePrice = Number(item?.salePrice || 0);
        item.imeiNumber = Number(item?.imeiNumber);
        item.minquantity = Number(item?.minquantity || 0);
        item.price = Number(item?.price || 0);
        item.quantity = Number(item?.quantity || 0);
        item.saleQuantity = Number(item?.saleQuantity || 0);
        item.steelWeightKg = Number(item?.steelWeightKg || 0);
        item.steelWeightTotal = Number(item?.steelWeightTotal || 0);
        return item;
      });
      console.log("newItems", newItems);

      //    let saleQuantity = items.map((item) => {
      //     console.log("item.saleQuantity", item.saleQuantity)
      //     item.saleQuantity = typeof item.saleQuantity === "number"
      //       ? item.saleQuantity
      //       : Number(item?.saleQuantity || 0);
      //     return item.saleQuantity;
      // }).join();

      // let saleQuantityUpdated = (Number(saleQuantity) - Number(copyBill.saleQuantity))
      // console.log('saleQuantity', saleQuantityUpdated)
      // console.log(' saleQuantity',  saleQuantity)

      //   console.log('saleQuantity',      copyBill.saleQuantity)

      console.log("billllllllllllllllll", Bill);

      dispatch(clearInventory());

      let updated = [];
      let sales = [];
      let hist = [];
      let noti = [];

      items.forEach((item) => {
        let itemPrice = item.salePrice ? item.salePrice : item.price;
        let minQuantity = item.minQuantity
          ? item.minQuantity
          : item.minquantity;
        let { saleQty } = convertToRFT(allbill.saleType, item, "");
        let found = allbill.items.find((i) => i._id == item._id);
        if (found) {
          let qty = convertToRFT(allbill.saleType, found, "").saleQty;
          let currentQty = saleQty - qty;
          console.log("CurrentQty", currentQty);

          if (currentQty > 0) {
            let newItem = {
              _id: item._id,
              saleQuantity: Number(currentQty),
              salePrice: itemPrice,
            };
            updated.push(newItem);
            let sale = {
              timestamp: Math.floor(Date.now() / 1000),
              category: item.category,
              unit: item.unit,
              discount: item.discount,
              read: "false",
              date: moment().format("DD-MM-YYYY"),
              company_code: item.company_code,
              imgURL: item.imgURL,
              minQuantity: minQuantity || 0,
              quantity: currentQty || 0,
              description: item.description,
              itemId: item.itemId,
              name: item.name,
              totalPrice: Number(itemPrice * currentQty) || 0,
              totalProfit:
                parseFloat(itemPrice * currentQty) -
                  parseFloat(item.costPrice * currentQty) || 0,
              price: Number(item.costPrice) || 0,
              salePrice: Number(itemPrice) || 0,
              itemCode: item.itemCode,
              vendor: item.vendor,
              dateOfPurchase: item.dateOfPurchase,
            };
            sales.push(sale);

            console.log("sales", sale);
            if (Bill.ledger_id) {
              let ledgerHis = {
                company_code: item.company_code,
                ledger_id: allbill.ledger_id,
                ledgerType: "sale",
                item_id: item.itemId,
                itemName: item.name,
                itemPrice: itemPrice,
                sale_quantity: currentQty,
              };
              hist.push(ledgerHis);
            }
            if (item.quantity - currentQty - minQuantity <= 0) {
              let notification = {
                _id: item._id,
                data: "Its time to re order " + item.name + " stock again!",
                timestamp: Math.floor(Date.now() / 1000),
                read: "false",
                weight: item.weightType
                  ? parseFloat(item.weight - currentQty)
                  : 0,
                quantity: item.weightType
                  ? 0
                  : parseFloat(item.quantity - currentQty),
              };

              noti.push(notification);
            }
          } else if (currentQty < 0) {
            let newItem = {
              _id: item._id,
              purchaseQuantity: Math.abs(currentQty),
              salePrice: itemPrice,
            };
            updated.push(newItem);
            let sale = {
              timestamp: Math.floor(Date.now() / 1000),
              category: item.category,
              unit: item.unit,
              discount: item.discount,
              read: "false",
              date: moment().format("DD-MM-YYYY"),
              company_code: item.company_code,
              imgURL: item.imgURL,
              minQuantity: Number(minQuantity) || 0,
              quantity: Number(currentQty) || 0,
              description: item.description,
              itemId: item.itemId,
              name: item.name,
              totalPrice: parseFloat(itemPrice * currentQty),
              totalProfit:
                parseFloat(itemPrice * currentQty) -
                parseFloat(item.costPrice * currentQty),
              price: Number(item.costPrice) || 0,
              salePrice: Number(-itemPrice),
              itemCode: item.itemCode,
              vendor: item.vendor,
              dateOfPurchase: item.dateOfPurchase,
            };
            sales.push(sale);
            console.log("sales", sale);
          }
        } else {
          // let newItem = { _id: item._id, saleQuantity: saleQty ,    salePrice: itemPrice};
          let newItem = {
            _id: item._id,
            saleQuantity: Number(currentQty),
            salePrice: itemPrice,
          };

          updated.push(newItem);
          let sale = {
            timestamp: Math.floor(Date.now() / 1000),
            category: item.category,
            unit: item.unit,
            discount: item.discount || 0,
            read: "false",
            date: moment().format("DD-MM-YYYY"),
            company_code: item.company_code,
            imgURL: item.imgURL,
            minQuantity: Number(minQuantity) || 0,
            quantity: Number(saleQty) || 0,
            description: item.description,
            itemId: item.itemId,
            name: item.name,
            totalPrice: parseFloat(itemPrice * saleQty),
            totalProfit:
              parseFloat(itemPrice * saleQty) -
              parseFloat(item.costPrice * saleQty),
            price: Number(item.costPrice) || 0,
            salePrice: Number(itemPrice) || 0,
            itemCode: item.itemCode,
            vendor: item.vendor,
            dateOfPurchase: item.dateOfPurchase,
          };
          sales.push(sale);
          console.log("sales", sale);

          if (Bill.ledger_id) {
            let ledgerHis = {
              company_code: item.company_code,
              ledger_id: allbill.ledger_id,
              ledgerType: "sale",
              item_id: item.itemId,
              itemName: item.name,
              itemPrice: Number(itemPrice) || 0,
              sale_quantity: Number(saleQty) || 0,
            };
            hist.push(ledgerHis);
          }
        }
      });
      allbill.items.forEach((i) => {
        let itemPrice = i.salePrice ? i.salePrice : i.price;
        let { saleQty } = convertToRFT(allbill.saleType, i, "");
        let minQuantity = i.minQuantity ? i.minQuantity : i.minquantity;
        let found = items.find((ii) => ii._id == i._id);
        if (!found) {
          console.log("deleted");
          let newItem = {
            _id: i._id,
            purchaseQuantity: i.saleQuantity ?? 1,
          };
          updated.push(newItem);
          let sale = {
            timestamp: Math.floor(Date.now() / 1000),
            category: i.category,
            unit: i.unit,
            discount: i.discount,
            read: "false",
            date: moment().format("DD-MM-YYYY"),
            company_code: i.company_code,
            imgURL: i.imgURL,
            minQuantity: Number(minQuantity) || 0,
            quantity: Number(-saleQty) || 0,
            description: i.description,
            itemId: i.itemId,
            name: i.name,
            totalPrice: -parseFloat(itemPrice * saleQty),
            totalProfit:
              -parseFloat(itemPrice * saleQty) -
              parseFloat(i.costPrice * saleQty),
            price: Number(-i.costPrice) || 0,
            salePrice: Number(-itemPrice) || 0,
            itemCode: i.itemCode,
            vendor: i.vendor,
            dateOfPurchase: i.dateOfPurchase,
          };
          sales.push(sale);
        }
        console.log("sales", sales);
        console.log("sales", updated);
      });

      if (
        hist.length > 0 &&
        noti.length > 0 &&
        sales.length > 0 &&
        updated.length > 0
      ) {
        Promise.all([P1(sales), P3(updated), P2(hist), P4(noti)]);
      } else {
        if (noti.length > 0 && sales.length > 0 && updated.length > 0) {
          Promise.all([P1(sales), P3(updated), P4(noti)]);
        } else if (hist.length > 0 && sales.length > 0 && updated.length > 0) {
          Promise.all([P1(sales), P3(updated), P2(hist)]);
        } else if (hist.length > 0 && noti.length > 0 && updated.length > 0) {
          Promise.all([P3(updated), P2(hist), P4(noti)]);
        } else if (hist.length > 0 && noti.length > 0 && sales.length > 0) {
          Promise.all([P1(sales), P3(updated), P2(hist), P4(noti)]);
        } else {
          if (hist.length > 0 && noti.length > 0) {
            Promise.all([P2(hist), P4(noti)]);
          } else if (sales.length > 0 && updated.length > 0) {
            Promise.all([P1(sales), P3(updated)]);
          } else if (hist.length > 0 && updated.length > 0) {
            Promise.all([P3(updated), P2(hist)]);
          } else if (noti.length > 0 && sales.length > 0) {
            Promise.all([P1(sales), P4(noti)]);
          } else if (hist.length > 0 && sales.length > 0) {
            Promise.all([P1(sales), P2(hist)]);
          } else if (noti.length > 0 && updated.length > 0) {
            Promise.all([P3(updated), P4(noti)]);
          } else {
            if (hist.length > 0) {
              Promise.all([P2(hist)]);
            } else if (sales.length > 0) {
              Promise.all([P1(sales)]);
            } else if (updated.length > 0) {
              Promise.all([P3(updated)]);
            } else if (noti.length > 0) {
              Promise.all([P4(noti)]);
            }
          }
        }
      }

      if (Bill.ledger_id) {
        let { data } = await LedgersRepository.ledgerModel({
          request: {
            method: "getLedger",
            data: {
              _id: Bill.ledger_id,
            },
          },
        });
        let ledger = data.response.data.ledger;
        console.log("ledgerr", ledger);
        // ledger.sale.depositedAmount = Number(ledger.sale.depositedAmount) + Number(state.new_paid)
        // console.log('led', ledger)
        let found = ledger.sale.find(
          (i) =>
            i.detail == `Item Sale ${Bill.billNumber}` ||
            i.detail == `Bill Number ${Bill.billNumber}`
        );

        console.log(found);

        console.log("billNumber", Bill.billNumber);
        found.depositedAmount =
          Number(found.depositedAmount) + Number(state.new_paid);
        console.log("led", ledger);
        console.log("found", found);

        found.totalAmount = totalPrice()?.Total;
        found.remainingAmount =
          totalPrice()?.Total - parseFloat(found.depositedAmount);
        await updateEntry(ledger, found.srNum, "sale");

        if (paid) {
          let entry = {
            _id: Bill.ledger_id,
            srNum: uuidv4(),
            billNumber: Bill.billNumber,
            paid: parseFloat(paid),
          };
          console.log("copyBill", copyBill);
          console.log("copyBill", entry);

          Promise.all([updateBill(copyBill), updateSaleLedger(entry)])
            .then((val) => {
              setTimeout(() => {
                history.push("/inventory/admin/bills");
              }, 200);
            })
            .catch((err) => {
              console.log(err);
              setLoading(false);
            });
        } else {
          await BillsRepository.billsModel({
            request: {
              method: "updateBill",
              data: {
                bill: copyBill,
              },
            },
          });
          setLoading(false);
          history.push("/inventory/admin/bills");
        }
      } else {
        console.log("else");
        await BillsRepository.billsModel({
          request: {
            method: "updateBill",
            data: {
              bill: copyBill,
            },
          },
        });

        setLoading(false);
        history.push("/inventory/admin/bills");
      }
      if (copyBill.paymentMethod == "cash") {
        console.log("cashInHand");
        await updateBillInCashInHand(copyBill);
      } else {
        console.log("cashInBank");

        await updateBillInBank(copyBill);
      }
    } catch (err) {
      console.log(err);
      setLoading(false);
    }
  };

  const selectForReturn = (item) => {
    let itemId;
    if (item._id) {
      itemId = item._id;
    } else if (item.id) {
      itemId = item.id;
    }
    if (parseInt(item.sold_quantity) < 1 || !item.sold_quantity) {
      Toast("info", "Provide valid quantity before selecting");
      return;
    }
    let copyItems = JSON.parse(JSON.stringify(items));
    let found = copyItems.find((findItem) => {
      let currentId;
      if (findItem._id) {
        currentId = findItem._id;
      } else if (findItem.id) {
        currentId = findItem.id;
      }
      if (currentId == itemId) {
        return findItem;
      }
    });

    if (found.itemToReturn === true) {
      found.itemToReturn = false;
    } else if (found.itemToReturn === false) {
      found.itemToReturn = true;
    } else {
      found.itemToReturn = true;
    }
    setItems(copyItems);
  };

  const returnSelectedItems = async () => {
    console.log("items", items);
    console.log("bills", Bill);
    setLoading(true);
    let returned_items = [];
    let keep_items = [];
    let retain = [];
    items.forEach((eachItem) => {
      if (eachItem.itemToReturn == true) {
        let { soldQty } = convertToQty(Bill.saleType, eachItem, "soldQty");

        eachItem.sold_quantity = soldQty;
        let copyItem = JSON.parse(JSON.stringify(eachItem));

        let finalQuantity = parseFloat(
          copyItem.saleQuantity - copyItem.sold_quantity
        );

        if (finalQuantity > 0) {
          returned_items.push({
            ...copyItem,
            saleQuantity: copyItem.sold_quantity,
          });
          keep_items.push({ ...copyItem, saleQuantity: finalQuantity });
        } else if (finalQuantity == 0) {
          returned_items.push(copyItem);
        }
      } else {
        retain.push(eachItem);
      }
    });

    let finalRetain = JSON.parse(JSON.stringify([...retain, ...keep_items]));
    finalRetain.forEach((finalItem) => {
      if (finalItem.sold_quantity) {
        delete finalItem.sold_quantity;
      }
      if (finalItem.itemToReturn) {
        delete finalItem.itemToReturn;
      }
    });
    console.log(totalPrice().Total);
    await BillsRepository.billsModel({
      request: {
        method: "updateBill",
        data: {
          bill: {
            _id: Bill._id,
            _rev: Bill._rev,
            company_code: Bill.company_code,
            items: finalRetain,
            date: moment().format("DD-MM-YYYY"),
            subTotal: Bill.subTotal,
            paid: Bill.paid,
            saleType: Bill.saleType,
            discount: Bill.discount,
            total: totalPrice().Total,
            billNumber: Bill.billNumber,
            discount_type: Bill.discount_type,
            discount_text: Bill.discount_text,
            seller: localStorage.getItem("token"),
            customer: Bill.customer,
            outstandingBalance:
              Math.abs(Bill.change) > 0 ? Math.abs(Bill.change) : "0",
            change: Bill.change,
            notes: Bill.notes,
            warehouseBill: Bill.warehouseBill,
            profit: Bill.profit,
            ledger_id: Bill.ledger_id,
            formallyOutstandings: Bill.formallyOutstandings,
            paymentMethod: Bill.paymentMethod,
            bankName: Bill.bankName,
            bankId: Bill.bankId,
          },
          returned_items: returned_items,
        },
      },
    });
    let returnAmount = 0;
    returned_items.map((retItem) => {
      let { totalPrice } = convertToRFT(Bill.saleType, retItem, "", "ignore");
      returnAmount += totalPrice;
    });

    let rem = Number(allbill.subTotal) - Number(allbill.paid);
    if (returnAmount < rem) {
      rem = returnAmount;
    }
    console.log("billlllll", Bill);
    console.log("billlllll", Bill.paid);

    if (Bill.paid > 0) {
      if (Bill.paymentMethod == "cash") {
        await returnSelectedInCashInHand(Bill, returnAmount);
      } else if (Bill.paymentMethod == "bank") {
        await returnSelectedInBank(Bill, returnAmount);
      }
    }
    // await LedgersRepository.ledgerModel({
    //   request: {
    //     method: "updateSaleLedger",
    //     data: {
    //       _id: Bill?.ledger_id,
    //       sale: {
    //         srNum: uuidv4(),
    //         date: +new Date(),
    //         detail: `Returned Bill Number ${Bill?.billNumber}`,
    //         billNumber: Bill?.billNumber,
    //         totalAmount: returnAmount,
    //         depositedAmount: 0,
    //         remainingAmount: rem ? -rem : 0,
    //         isReturn: true,
    //       },
    //     },
    //   },
    // });

    if (Bill.ledger_id) {
      let srLedgerNum;
      try {
        const { data } = await Repo.ledger({
          request: {
            method: "getSaleLedgersById",
            data: {
              _id: Bill.ledger_id,
            },
          },
        });

        console.log("dataaa", data.response.data.saleLedgers);
        srLedgerNum = data?.response?.data?.saleLedgers?.find((item, index) => {
          item.ledgerId == Bill.ledger_id;
          return item.srNum;
        });
      } catch (err) {
        console.log("Error fetching ledger data:", err);
      }

      console.log("srrr", srLedgerNum);

      console.log("billtotalAmount", srLedgerNum.totalAmount);
      console.log("rem", rem);
      console.log("returnamount", returnAmount);

      try {
        let { data } = await LedgersRepository.ledgerModel({
          request: {
            method: "updateLedgerEntry",
            data: {
              company_code: Bill.company_code,
              ledgerId: Bill.ledger_id,
              ledgerType: "sale",
              srNum: srLedgerNum.srNum,
              updatedLedgerEntry: {
                detail: `Bill Number ${Bill?.billNumber}`,
                totalAmount:
                  Number(srLedgerNum.totalAmount) - Number(returnAmount),
                depositedAmount: rem
                  ? Number(srLedgerNum.depositedAmount)
                  : Number(srLedgerNum.totalAmount) - Number(returnAmount),
                remainingAmount: rem
                  ? Number(srLedgerNum.totalAmount) -
                    Number(returnAmount) -
                    Number(srLedgerNum.depositedAmount)
                  : 0,
                isReturn: true,
              },
            },
          },
        });
        if (data.response.data.ledgerId) {
          Toast("success", "Ledger Entry Updated");
        }
      } catch (err) {
        console.log(err);
        Toast("error", "Error");
        history.push("/inventory/admin/ledgers");
      }
    }
    setLoading(false);
    dispatch(clearInventory());
    history.push("/inventory/admin/bills");
  };

  const updateStatus = async () => {
    try {
      const response = await Repo.bills({
        request: {
          method: "updateBillStatus",
          data: {
            _id: Bill?._id,
          },
        },
      });

      // Process the response as needed
      console.log("Response:", response);
      if (response.data.response.status.statusCode == 200) {
        Toast("success", "Status Updated");
        history.push("/inventory/admin/bills");
      }
      return response;
    } catch (error) {
      // Handle any errors that occur during the request
      console.error("Error updating bill status:", error);
      throw error;
    }
  };

  const returnPaidBill = async () => {
    const newItems = items.map((item) => {
      const value = item.weight ? item.weight + item.saleQuantity : item.weight;
      if (value) {
        item.weight = value;
      }
      console.log("value", value);
      console.log("valueItem", item);

      return item;
    });
    let Total = totalPrice()?.Total;
    setLoading(true);
    let copyBill = JSON.parse(JSON.stringify(Bill));
    copyBill.sale_return = "true";
    copyBill.date = moment().format("DD-MM-YYYY");
    copyBill.items = newItems;
    copyBill.finalTotal = Total;
    copyBill.total = Total;
    copyBill.outstandingBalance =
      Math.abs(Total) - Bill.paid > 0 ? Math.abs(Total) - Bill.paid : "0";
    copyBill.weight = copyBill.weight
      ? copyBill.weight + copyBill.saleQuantity
      : copyBill.weight;
    console.log("copyyyyyyy", copyBill);
    copyBill.change =
      Bill.paid >= Total
        ? 0
        : Math.abs(Total - Bill.paid) > 0
        ? Math.abs(Total - Bill.paid)
        : "0";
    delete copyBill.totalItems;
    await BillsRepository.billsModel({
      request: {
        method: "updateBill",
        data: {
          bill: copyBill,
        },
      },
    });
    let rem = allbill.total - allbill.paid;
    if (Total < rem) {
      rem = Total;
    }
    console.log("copyyyybill", copyBill);
    if (copyBill.paid > 0) {
      if (copyBill.paymentMethod == "cash") {
        await returnFullBillInCashInHand(copyBill);
      } else if (copyBill.paymentMethod == "bank") {
        await returnFullBillInBank(copyBill);
      }
    }
    await LedgersRepository.ledgerModel({
      request: {
        method: "updateSaleLedger",
        data: {
          _id: Bill?.ledger_id,
          sale: {
            srNum: uuidv4(),
            date: +new Date(),
            detail: `Returned Bill Number ${Bill?.billNumber}`,
            billNumber: Bill?.billNumber,
            totalAmount: Total,
            depositedAmount: 0,
            remainingAmount: rem ? -rem : 0,
            isReturn: true,
          },
        },
      },
    });

    setLoading(false);
    history.push("/inventory/admin/return-bills");
  };

  const toggle = () => {
    // if (
    //   Bill.formallyOutstandings && Bill.formallyOutstandings != "0"
    //     ? Number(totalPrice().Total) +
    //       Number(Bill.formallyOutstandings ?? 0) -
    //       Number(Bill.paid ?? 0)
    //     : Number(totalPrice().Total) - Number(Bill?.paid ?? 0) < 0
    // ) {
    //   Toast("info", "Paid Amount Cannot Be Greater Than Total Amount");
    //   return;
    // }
    setModal((prevState) => !prevState);
  };

  const handleInput = (e, index) => {
    const copyItems = JSON.parse(JSON.stringify(items));
    copyItems[index][e.target.name] = e.target.value;
    setItems(copyItems);
  };

  const handlePaid = (e) => {
    const { name, value } = e.target;

    setState((prevState) => ({
      ...prevState,
      [name]: value,
    }));

    let copyBill = JSON.parse(JSON.stringify(Bill));
    console.log("val", value);
    console.log("all", allbill.paid);

    if (name == "discount") {
      copyBill.discount = value;
    } else if (name == "new_paid") {
      copyBill.change = Math.abs(allbill.change - value);
      copyBill.new_paid = state.new_paid;
      copyBill.paid = parseInt(allbill.paid) + parseInt(value);
    } else if (name == "paid") {
      // copyBill.new_paid = parseInt(allbill.paid) + parseInt(value) + Number(copyBill.discount);
    } else if (name == "customer") {
      copyBill.customer = value;
      console.log("vllll", value);
    }
    setBill(copyBill);
  };
  const handleSearch = (e) => {
    const { value } = e.target;
    setSearchText(value);
  };
  const searchedItems = () => {
    if (searchText) {
      return inventory.filter((item) =>
        item?.name.toLowerCase().includes(searchText)
      );
    } else {
      return [];
    }
  };
  const addToSelected = (item) => {
    console.log("itemmmm", item);
    let copy = JSON.parse(JSON.stringify(items));
    let foundIndex = copy.findIndex((i) => i._id == item._id);
    let newItemsArray = [];
    if (foundIndex != -1) {
      copy.splice(foundIndex, 1);
    } else {
      const newItem = { ...item, saleQuantity: 1 };
      // const newAddedItem = {
      //   ...item,
      //   saleQuantity: 1
      //  }
      console.log("newItem", newItem);
      copy.push(newItem);
      // newItemsArray?.push(newAddedItem);
    }

    console.log("copyyyyy", copy);
    console.log("newItemsArray", newItemsArray);

    // setAddedItem(newItemsArray);
    setItems(copy);
    setValue(true);
  };
  const handleRemove = (index) => {
    let copy = JSON.parse(JSON.stringify(items));
    copy.splice(index, 1);
    setItems(copy);
  };

  return (
    <Box sx={{ mt: 2 }}>
      <Grid container justifyContent="flex-end">
        <Grid item xs={12} sx={{ mb: 3 }}>
          <HeadRow sx={{ mt: { md: "0px", xs: "30px" } }}>
            <Typography align="center" className="f-11-lh">
              #
            </Typography>
            <Typography className="f-11-lh">Item</Typography>
           <Typography className="f-11-lh">Return Type</Typography>
            <Typography className="f-11-lh" sx={{textAlign:"center"}}>Disc%</Typography>
            <Typography className="f-11-lh f-11-lh-overflow">
              Sale Qty
            </Typography>
            <Typography className="f-11-lh f-11-lh-overflow">
              Return Qty
            </Typography>
            <Typography className="f-11-lh">U Price</Typography>
            <Typography className="f-11-lh f-11-lh-overflow">
              Total Price
            </Typography>
          </HeadRow>
          {items.map((item, index) => {
            let {
              saleQty,
              itemPrice,
              totalPrice,
              discountAmount,
              itemDiscount,
            } = convertToRFT(Bill.saleType, item, "");

            return (
              <ValuesRow key={index}>
                <Stack direction="row">
                  {item.itemToReturn == true && (
                    <i
                      className="fa fa-check center text-success"
                      aria-hidden="true"
                    ></i>
                  )}
                  <Typography className="f-11-lh">{index + 1}</Typography>
                </Stack>

                <Typography className="f-11-lh">{item.name}</Typography>
                {/* {item?.box == true && (
                  <FormControl >
                    <InputLabel id="sale-type-label">Sale Type</InputLabel>
                    <Select
                      labelId="sale-type-label"
                      id="sale-type"
                      name="returnType"
                      value={item?.returnType}
                      label="Return Type"
                      onChange={(e) =>  handleInput(e, index)}
                    >
                      <MenuItem value="box">
                        {item.saleLabel == "box" ? "By Box" : "By Ctn"}
                      </MenuItem>
                      <MenuItem value="pieces">
                        {item.saleLabel == "box" ? "By Pieces" : "By Box"}
                      </MenuItem>
                    </Select>
                  </FormControl>
                )} */}
                <Typography className="f-11-lh" sx={{textAlign:"center"}}>{itemDiscount}</Typography>
                <TextField
                  sx={{ width: "80%" }}
                  size="small"
                  type="number"
                  variant="standard"
                  name="saleQuantity"
                  value={saleQty}
                  className="f-11-lh"
                  onChange={(e) => handleInput(e, index)}
                />
                <TextField
                  sx={{ width: "80%" }}
                  size="small"
                  type="number"
                  variant="standard"
                  name="sold_quantity"
                  className="f-11-lh"
                  max={saleQty}
                  min="0"
                  value={item.sold_quantity || ""}
                  onChange={(e) => {
                    if (parseInt(e.target.value) > parseFloat(saleQty)) {
                      Toast(
                        "info",
                        "Return quantity less or equal to sale quantity"
                      );

                      return;
                    }
                    handleInput(e, index);
                  }}
                />
                <TextField
                  sx={{ width: "80%" }}
                  size="small"
                  variant="standard"
                  type="number"
                  name="salePrice"
                  min="0"
                  className="f-11-lh"
                  value={item.salePrice ?? itemPrice}
                  onChange={(e) => handleInput(e, index)}
                />
                <Typography className="f-11-lh">{totalPrice}</Typography>
                <Stack direction="row" justifyContent="space-between">
                  <CheckCircleIcon
                    sx={{
                      cursor: "pointer",
                      color: item.itemToReturn ? "#4eaf51" : "grey",
                    }}
                    onClick={(e) => selectForReturn(item)}
                    className="ml-negative"
                  />
                  <img
                    style={{ cursor: "pointer", width: "15px" }}
                    src={deleteIcon}
                    alt=""
                    onClick={() => handleRemove(index)}
                  />
                </Stack>
              </ValuesRow>
            );
          })}
        </Grid>
        <Grid item lg={9} md={6} xs={12} sx={{ padding: "4px  15px" }}>
          <Search
            name={"searchText"}
            text={"Search item..."}
            value={searchText}
            onChange={handleSearch}
          />
          <Box sx={{ mt: 1, maxHeight: "380px", overflowY: "auto" }}>
            {searchedItems().map((item, index) => {
              return (
                <ItemBox key={index} onClick={() => addToSelected(item)}>
                  <img
                    style={{ width: "15px" }}
                    src={checkIds[item._id] ? tick : ""}
                    alt=""
                  />

                  <Typography variant="h6">{item?.name}</Typography>

                  <Stack>
                    <Typography>Code:</Typography>{" "}
                    <Typography>
                      <b>{item.itemCode ? item.itemCode : item.itemId}</b>
                    </Typography>
                  </Stack>
                  <Stack>
                    <Typography>Sale Price:</Typography>
                    <Typography>
                      <b>{item.price}</b>
                    </Typography>
                  </Stack>
                  <Stack>
                    <Typography>Cost Price:</Typography>{" "}
                    <Typography>
                      <b>{item.costPrice}</b>
                    </Typography>
                  </Stack>

                  <Stack>
                    <Typography sx={{ color: "#4eaf51" }}>
                      {getQty(item).type}
                    </Typography>
                    <Typography>{getQty(item)?.qty}</Typography>
                  </Stack>
                </ItemBox>
              );
            })}
          </Box>
        </Grid>
        <Grid item lg={3} md={6} sm={8} xs={12}>
          <TotalBox>
            <Stack direction="row" justifyContent="space-between">
              <Typography>Sub Total:</Typography>
              <Typography>{totalPrice()?.subTotal}</Typography>
            </Stack>
            <hr></hr>
            <Stack direction="row" justifyContent="space-between">
              <Typography>Discount:</Typography>
              {/* <Typography>
                {Bill.discount_type == "percentage"
                  ? Bill.discount_text == null
                    ? Bill.discount
                    : Bill.discount_text
                  : Bill.discount}{" "}
                {Bill.discount_type == "percentage" ? "%" : "Rps"}
              </Typography> */}
              <TextField
                size="small"
                variant="standard"
                // className="input-paid  regular"
                name="discount"
                value={state.discount ? state.discount : Bill?.discount}
                type="number"
                onChange={handlePaid}
              />
              <Typography>
                {Bill.discount_type == "percentage" ? "%" : "Rps"}
              </Typography>
            </Stack>
            <hr></hr>
            <Stack direction="row" justifyContent="space-between">
              <Typography>Previous Balance:</Typography>
              <Typography>
                {Bill.formallyOutstandings ? Bill.formallyOutstandings : "0"}
              </Typography>
            </Stack>
            <hr></hr>
            <Stack direction="row" justifyContent="space-between">
              <Typography>Total:</Typography>
              <Typography>
                {Bill.formallyOutstandings
                  ? parseInt(Bill.formallyOutstandings + totalPrice()?.Total)
                  : totalPrice()?.Total}
              </Typography>
            </Stack>
            <hr></hr>
            <Stack direction="row" justifyContent="space-between">
              <Typography>Paid:</Typography>
              <Typography>{allbill.paid}</Typography>
            </Stack>
            <hr></hr>
            {allbill.paid < totalPrice()?.Total && (
              <>
                <Box sx={{ display: "grid", gridTemplateColumns: "50% 50%" }}>
                  <Box>
                    <Typography>New Paid:</Typography>

                    <TextField
                      size="small"
                      variant="standard"
                      // className="input-paid  regular"
                      name="new_paid"
                      // value={0}
                      defaultValue={0}
                      value={state?.new_paid ?? 0}
                      //  value={(state?.paid || allbill?.paid) ?? 0}
                      type="number"
                      onChange={handlePaid}
                    />
                  </Box>

                  <Box>
                    <Typography>Balance:</Typography>
                    <TextField
                      disabled
                      variant="standard"
                      size="small"
                      // className="input-paid  regular"
                      onChange={handlePaid}
                      name="balance"
                      value={
                        Bill.formallyOutstandings &&
                        Bill.formallyOutstandings != "0"
                          ? Number(totalPrice().Total) +
                            Number(Bill.formallyOutstandings ?? 0) -
                            Number(Bill.paid ?? 0)
                          : Number(totalPrice().Total) - Number(Bill?.paid ?? 0)
                      }
                      defaultValue={0}
                    />
                  </Box>
                </Box>
                <hr></hr>
              </>
            )}
            <Stack direction="row" justifyContent="space-between">
              <Typography>Customer:</Typography>
              {/* <Typography>{Bill.customer}</Typography> */}
              <TextField
                name="customer"
                value={state.customer || Bill.customer}
                type="text"
                onChange={handlePaid}
              >
                {Bill.customer}
              </TextField>
            </Stack>
            <hr></hr>
            <Box align="center">
              {loading ? (
                <Loader loading={loading} />
              ) : (
                <>
                  {items.find(
                    (foundItem) => foundItem.itemToReturn == true
                  ) && (
                    <ReturnButton
                      variant="contained"
                      onClick={returnSelectedItems}
                    >
                      Return Selected Items
                    </ReturnButton>
                  )}

                  {/* {(paid != "0" || allbill.paid != totalPrice()?.Total) && ( */}
                  <ReturnButton variant="contained" onClick={toggle}>
                    Update Bill
                  </ReturnButton>
                  {/* )} */}

                  <ReturnButton variant="contained" onClick={returnPaidBill}>
                    Return Full Bill
                  </ReturnButton>

                  <ReturnButton variant="contained" onClick={updateStatus}>
                    Update Status
                  </ReturnButton>

                  {allbill.paid >= totalPrice()?.Total && (
                    <Typography sx={{ color: "#4daf51", fontWeight: "bold" }}>
                      Fully Paid
                    </Typography>
                  )}
                </>
              )}
            </Box>
          </TotalBox>
        </Grid>
      </Grid>
      <BillPreview
        title="Bill Preview"
        open={modal}
        onSale={sellItems}
        onClose={toggle}
        onClickCancel={toggle}
        bill={{
          ...Bill,
          items: items,
          total: totalPrice()?.Total,
          subTotal: totalPrice()?.subTotal,
          change:
            Bill.paid >= totalPrice()?.Total
              ? 0
              : Math.abs(totalPrice()?.Total - Bill.paid) > 0
              ? Math.abs(totalPrice()?.Total - Bill.paid)
              : "0",
          outstandingBalance:
            Math.abs(totalPrice()?.Total) - Bill.paid > 0
              ? Math.abs(totalPrice()?.Total) - Bill.paid
              : "0",
        }}
        sellItem={true}
        fivePercent="ignore"
      />
    </Box>
  );
}

export default UpdateBill;
